module.exports = __webpack_public_path__ + "img/radio-nature.8803c95a.png";